import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from './services/config.service';
import { VersionService } from './services/version.service';
import { CustomDatepickerI18nService } from './services/custom-datepicker-i18n.service';
import { CustomDatepickerFormaterService } from './services/custom-datepicker-formater.service';
import { ComponentHostDirective } from './directives/component-host.directive';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ErrorDefaultComponent } from './components/error-default/error-default.component';
import { NoDataMessageComponent } from './components/no-data-message/no-data-message.component';
import { DatePresentationPipe } from './pipes/date-presentation.pipe';
import { ErrorHandlerService } from './services/handlers/error.service';
import { ScreenMediaService } from './services/parameter/screen-media/screen-media.service';
import { BooleanStateService } from './services/boolean-state.service';
import { CanLoadParameterCheckRouteService } from './services/guard/can-load-parameter-check-route.base';
import { ApiService } from 'projects/communication/src/app/services';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { Common2Module } from 'projects/common/src/app/app.module';
import { CommunicationService } from 'src/app/services/communication';
import { VersionComponent } from './components/version/version.component';
import { CapsLockDirective } from './directives/caps-lock.directive';
import { ComponentCanViewDirective } from './directives/component-can-view.directive';
import { ComponentProviderDirective } from './directives/component-provider.directive';
import { DateTimePresentationPipe } from './pipes/date-time-presentation.pipe';
import { TimePresentationPipe } from './pipes/time-presentation.pipe';
import { TableComponent } from './components/table/table.component';
import { NgbModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdSortableHeaderDirective } from '../dashboard/directives/ngbdSortableHeader.directive';
import { FullTimePresentationPipe } from './pipes/full-time-presentation.pipe';
import { FullDateTimePresentationPipe } from './pipes/full-date-time-presentation.pipe';
import { SignalRMachineService } from './services/signal-r/signal-r-machine/singal-r-machine.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TableSortIconComponent } from './components/table-sort-icon/table-sort-icon.component';
import { MtTablePaginationComponent } from './components/mt-table-pagination/mt-table-pagination.component';
import { DateTimeSystemPipe } from './pipes/date-time-system.pipe';
import { RangeDatepickerComponent } from './components/range-datepicker/range-datepicker.component';
import { WithoutTimePresentationPipe } from './pipes/without-time-presentation.pipe';
import { InputDateFormatPipe } from './pipes/input-date-format.pipe';
import { DateTimeTextPipe } from './pipes/date-time-text.pipe';
import { SystemErrorMessageComponent } from './components/system-error-message/system-error-message.component';
import { FilterDateComponent } from './components/mt-filter/filter-date/filter-date.component';
import { FilterShiftComponent } from './components/mt-filter/filter-shift/filter-shift.component';
import { FilterMachineTypeComponent } from './components/mt-filter/filter-machine-type/filter-machine-type.component';
import { FilterMachineComponent } from './components/mt-filter/filter-machine/filter-machine.component';
import { MtFilterComponent } from './components/mt-filter/mt-filter.component';
import { FilterZoneComponent } from './components/mt-filter/filter-zone/filter-zone.component';
import { FilterFrontComponent } from './components/mt-filter/filter-front/filter-front.component';
import { FilterMineComponent } from './components/mt-filter/filter-mine/filter-mine.component';
import { FilterOperatorComponent } from './components/mt-filter/filter-operator/filter-operator.component';
import { FilterAllMineComponent } from './components/mt-filter/filter-all-mine/filter-all-mine.component';
import { LicenseBannerComponent } from './components/license-banner/license-banner.component';
import { ModalLogoutComponent } from './components/modal-logout/modal-logout.component';
import { HeaderSearchComponent } from './components/header-search/header-search.component';
import { SpinnerComponent } from './components/spinner/spinner.component';

@NgModule({
  declarations: [
    ComponentHostDirective,
    ProgressBarComponent,
    ErrorDefaultComponent,
    NoDataMessageComponent,
    DatePresentationPipe,
    DateTimePresentationPipe,
    DateTimeSystemPipe,
    VersionComponent,
    CapsLockDirective,
    ComponentCanViewDirective,
    ComponentProviderDirective,
    DateTimePresentationPipe,
    TimePresentationPipe,
    TableComponent,
    NgbdSortableHeaderDirective,
    FullDateTimePresentationPipe,
    FullTimePresentationPipe,
    DatepickerComponent,
    TableSortIconComponent,
    MtTablePaginationComponent,
    RangeDatepickerComponent,
    WithoutTimePresentationPipe,
    InputDateFormatPipe,
    DateTimeTextPipe,
    SystemErrorMessageComponent,
    FilterDateComponent,
    FilterShiftComponent,
    FilterMachineTypeComponent,
    FilterMachineComponent,
    MtFilterComponent,
    FilterZoneComponent,
    FilterFrontComponent,
    FilterMineComponent,
    FilterOperatorComponent,
    FilterAllMineComponent,
    ModalLogoutComponent,
    LicenseBannerComponent,
    HeaderSearchComponent,
    SpinnerComponent,
  ],
  imports: [CommonModule, Common2Module.forRoot(), FormsModule, ReactiveFormsModule, NgbModule, NgSelectModule, NgbTimepickerModule],
  exports: [
    ComponentHostDirective,
    ProgressBarComponent,
    ErrorDefaultComponent,
    NoDataMessageComponent,
    DatePresentationPipe,
    DateTimePresentationPipe,
    TimePresentationPipe,
    VersionComponent,
    CapsLockDirective,
    ComponentCanViewDirective,
    ComponentProviderDirective,
    TableComponent,
    NgbModule,
    NgbdSortableHeaderDirective,
    FullDateTimePresentationPipe,
    FullTimePresentationPipe,
    DateTimeSystemPipe,
    DatepickerComponent,
    TableSortIconComponent,
    MtTablePaginationComponent,
    NgSelectModule,
    TableSortIconComponent,
    WithoutTimePresentationPipe,
    InputDateFormatPipe,
    MtTablePaginationComponent,
    SystemErrorMessageComponent,
    FilterDateComponent,
    FilterShiftComponent,
    FilterMachineTypeComponent,
    FilterMachineComponent,
    MtFilterComponent,
    LicenseBannerComponent,
    HeaderSearchComponent,
    SpinnerComponent,
  ],
  providers: [
    InputDateFormatPipe,
    ConfigService,
    VersionService,
    ScreenMediaService,
    CustomDatepickerI18nService,
    BooleanStateService,
    CustomDatepickerFormaterService,
    CanLoadParameterCheckRouteService,
    SignalRMachineService,
    WithoutTimePresentationPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfig: ParameterHandlerService) => () => appConfig,
      deps: [ParameterHandlerService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService,
    },
    {
      provide: CommunicationService,
      useClass: ApiService,
    },
  ],
})
export class CoreModule {}
